<template>
	<div class="banner1" v-if="games.length>0">
		<slider :indicators="true" v-model="sliderIndex" :touch="true" :interval="2500" :speed="1000" :autoplay="true" :control-btn="false" animation="normal"
			class="bannerSwiper" style="width: 100vw; height: 100%;">
			<slider-item
				v-for="(item,index) in games"
				:key="index.toString()"
				class="slideritem"
				:style="{'backgroundImage': 'url(' + item.bg + ')'}"
				>
			</slider-item>
		</slider>
		
		<div id="" class="icon-box">
			<div class="icon-box-item">
				<div id="" class="icon-box-item-left">
					<img :src="games[sliderIndex].icon" >
				</div>
				<div class="icon-box-item-right">
<!-- 					<div id="">
						<div @click="chooseGameItem(i)" :class="i === sliderIndex ? 'icon-box-item-right-icon icon-box-item-right-icon-bg' : 'icon-box-item-right-icon'" id="" v-for="(item, i) in games" :key="item.icon">
							<img :src="item.icon" >
						</div>
					</div> -->
					<div class="footer">
						<p>
							<a target="_blank" :href="urls[sliderIndex].google ? urls[sliderIndex].google : 'JavaScript:void(0)'"><img src="../../assets/google.png" ></a>
						</p>
						<p>
							<a target="_blank" :href="urls[sliderIndex].ios ? urls[sliderIndex].ios :'JavaScript:void(0)'">
								<img src="../../assets/ios.png" >
							</a>
						</p>
						
						
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		Slider,
		SliderItem
	} from 'vue-easy-slider'
	export default {
		props: ['curpage', 'aniDownUp'],
		components: {
			Slider,
			SliderItem
		},
		data() {
			return {
				sliderIndex: 0,
				urls: [
					// {
					// 	ios: 'https://apps.apple.com/us/app/bingo-journey-real-bingo-games/id1442895889',
					// 	google: 'https://play.google.com/store/apps/details?id=com.bingo.scape.android.free',
					// 	name: 'BINGO Journey'
					// }, 
					// {
					// 	ios: 'https://apps.apple.com/app/id1265838130',
					// 	google: 'https://play.google.com/store/apps/details?id=com.bingo.tour.party.crazy.free&hl=None',
					// 	name: 'BINGO Party'
					// }, 
					{
						ios: '',
						google: 'https://play.google.com/store/apps/details?id=com.bingo.riches',
						name: 'BINGO Riches'
					}, {
						ios: '',
						google: 'https://play.google.com/store/apps/details?id=com.bingo.island.android',
						name: 'BINGO ISLAND'
					}, {
						ios: '',
						google: '',
						name: 'BINGO Crown'
					}, {
						ios: 'https://apps.apple.com/app/id1382108510',
						google: 'https://play.google.com/store/apps/details?id=com.huge.slots.casino.vegas.android.avidly&hl=None',
						name: 'DOUBLE WIN'
					}, {
						ios: 'https://itunes.apple.com/app/id1247414258',
						google: 'https://play.google.com/store/apps/details?id=com.citrusjoy.trojan&hl=None',
						name: 'HUGE WIN'
					}, {
						ios: 'https://apps.apple.com/us/app/id1499936245',
						google: 'https://play.google.com/store/apps/details?id=com.jackpot.fever.slots.android',
						name: 'Cash Hoard Slots'
					},
					{
						ios: 'https://apps.apple.com/app/id1499756879',
						google: 'https://play.google.com/store/apps/details?id=com.vegasparty.slots.casino.android&hl=None',
						name: 'Vegas PARTY'
					},
					{
						ios: '',
						google: 'https://play.google.com/store/apps/details?id=com.bravo.slots.casino.android&hl=None',
						name: 'LUCKY HIT SLOTS'
					}, 
					// {
					// 	ios: 'https://apps.apple.com/TW/app/id1447078784',
					// 	google: 'https://play.google.com/store/apps/details?id=com.golden.fishing.android.avidly',
					// 	name: '黄金捕鱼场'
					// }, 
					{
						ios: 'https://apps.apple.com/us/app/id1563868458',
						google: 'https://play.google.com/store/apps/details?id=com.fishing.billionaire.android',
						name: '神豪捕鱼'
					}  
				],
				games: []
			}
		},
		watch: {
			'curpage': {
				handler(newvalue, oldvalue) {
					if (newvalue === 1) {
						this.sliderIndex = 0
					}
				},
				immediate: true
			},
		},
		mounted() {
			this.games = []
			let bg_suff = 'jpg'
			let icon_suff = 'png'
			for (let i = 1; i <= 12; i++) {
				if (i !== 1 && i !== 2 && i !== 11) { // 去掉bingoparty 和bingo jouney 和黄金捕鱼
					let item = {
						icon: require(`../../assets/game/icon/icon_${i}.${icon_suff}`),
						bg: require(`../../assets/game/bg/bg_${i}.${bg_suff}`)
					}
					this.games.push(item)
				}
				
			}
		},
		methods: {
			chooseGameItem (i) {
				this.sliderIndex = i
			}
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep .slider-btn{
		display: none !important;
	}
	::v-deep .slider-indicators {
		z-index: 9999 !important;
	}
	::v-deep .slider-indicator-icon {
		background-color: #FFFFFF !important;
		margin: 1px 0.1rem !important;
		border: 1px solid #fff !important;
		width: 10px !important;
		height: 10px !important;
	}
	::v-deep .slider-indicator-active {
		background-color: rgba(0, 0, 0, 0.4) !important;
	}
	.banner1 {
		height: 100vh;
		background-repeat:no-repeat;
		background-size: 100%;
		background-size: cover;
		text-align: left;
		box-sizing: border-box;
		font-family: 'PilatTest-Bold';
		position: relative;
		box-sizing: border-box;
		padding-top: 80px;
		.bannerSwiper {
			.slideritem {
				width: 100vw;
				height: 100%;
				background-repeat: no-repeat;
				background-size: cover;
				background-position: center;
			}
		}
		.icon-box {
			position: absolute;
			background-image: url(../../assets/baise.png);
			background-size: cover;
			background-position: center;
			width: 100vw;
			left: 50%;
			transform: translateX(-50%);
			height: 60vh;
			box-sizing: border-box;
			padding-top: 20vh;
			// background-color: red;
			// bottom: 1.875rem;
			bottom: 0;
			z-index: 1000;
			.icon-box-item {
				position: absolute;
				bottom: 5%;
				// height: 70%;
				width: 60%;
				left: 50%;
				transform: translateX(-50%);
				// background-color: red;
				vertical-align: bottom;
				margin: 0 auto;
				display: flex;
				.icon-box-item-left {
					width: 50%;
					text-align: right;
					img {
						width: 40%;
						vertical-align: middle;
						margin-top: 7%;
					}
				}
				.icon-box-item-right {
					width: 70%;
					.icon-box-item-right-icon-bg {
						background-image: url(../../assets/iconbg.png);
					}
					.icon-box-item-right-icon {
						display: inline-block;
						background-repeat: no-repeat;
						background-size: cover;
						box-sizing: border-box;
						background-position: top center;
						padding: 0.3rem 0.2rem;
						width: 16.6%;
						text-align: center;
						img {
							vertical-align: middle;
							display: block;
							width: 90%;
						}
					}
					.footer {
						width: 100%;
						text-align: left;
						margin-top: 0.8325rem;
						img {
							width: 25%;
							margin: 0 0.625rem;
						}
					}
				}
			}
		}
	}
	
</style>
